import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as P from 'fp-ts/Predicate';
import * as s from 'fp-ts/string';
import * as RR from './ReadonlyRecord';
export * from 'fp-ts-std/String';
export * from 'fp-ts/string';
export var isNonEmpty = P.not(s.isEmpty);
/**
 * Add at the beginning of a string.
 *
 * ### Example
 * ```ts
 * pipe('foo', prepend('bar'))
 * // => 'foobar'
 * ```
 */
export var prepend = function (a) {
    return function (b) {
        return "".concat(a).concat(b);
    };
};
/**
 * Removes at the beginning of a string.
 *
 * ### Example
 * ```ts
 * pipe('foo', unprepend('foobar'))
 * // => 'bar'
 * ```
 */
export var unprepend = function (a) {
    return function (s) {
        return s.replace(new RegExp("^".concat(a)), '');
    };
};
export var firstHunk = function (s) {
    return pipe(s.match(/^(?<hunk>\w[a-z]+)[A-Z]*\w*/), O.fromNullable, O.chain(function (_a) {
        var groups = _a.groups;
        return O.fromNullable(groups);
    }), O.chain(RR.lookup('hunk')));
};
export var toUppercase = function (s) { return s.toUpperCase(); };
export var isUpperSnakeCase = function (s) { return /^[A-Z][_A-Z]*[A-Z]$/.test(s); };
export var toUpperSnakeCase = function (s) {
    return pipe(s, firstHunk, O.match(
    // can happen when s is empty string
    function () { return toUppercase(s); }, function (hunk) { return (s === hunk ? toUppercase(hunk) : "".concat(toUppercase(hunk), "_").concat(toUpperSnakeCase(s.replace(hunk, '')))); }));
};
